<template>
  <AutoCompleter ref="completer" :results="results" :placeholder="placeholder" :iid="iid" @reload="reload" @selected="selectValue">
    <template v-slot:listitem="data">
      {{ data.result.article_nr }} - {{ data.result.desc.short_des }} ({{ data.result.map_id }})
    </template>
  </AutoCompleter>
</template>

<script>
import articles from '@/modules/articles.js'
import AutoCompleter from '@/components/AutoCompleter.vue'

export default {
  name: 'ArticleAutoCompleter',
  props: {
    iid: { type: String, required: false, default : ''},
    placeholder: { type: String, required: false, default: ''}
  },
  components: {
    AutoCompleter,
  },
  data() {
    return {
      results: [],
    }
  },
  created: function() {
    articles.viewparams.start = 0;
    articles.viewparams.count = 20;
  },
  methods: {
    selectValue(data) {
      var link = { title: data.article_nr + ' ' + data.desc.short_des };
      this.$refs.completer.updateValue(data.map_id,link);
    },
    reload(search) {
      console.log(search);
      articles.viewparams.value = search;
      var self = this;
      articles.list(this,function(data) {
        self.results = data.result;
      })
    }
  }
}
</script>
